module.exports = __webpack_public_path__ + "static/f13-a20729adec72939419dc9a34d34ddf07.jpeg";